export const SUCCESS = 'success';
export const WARNING = 'warning';
export const ERROR = 'error';

export const ACTIVE_LISTING = 'active listing';
export const PENDING_LISTING = 'pending approval';
export const DRAFT_LISTING = 'draft listing';
export const COPY_LISTING = 'copy listing';
export const COPY_LISTING_DRAFT = 'copy listing draft';
export const ARCHIVED_LISTING = 'archived listing';
export const SENT_FOR_AMENDMENT = 'sent for amendment';

export const NEW = 'new';
export const EXISTING = 'existing';

export const BUYER = 'buyer';
export const SELLER = 'seller';
export const ADMIN = 'admin';

export const NOT_UPLOADED = 'Not uploaded';
export const PENDING_VERIFICATION = 'Pending verification';
export const USER_ACTION_REQUIRED = 'User action required';
export const VERIFIED = 'Verified';

export const NOT_REQUIRED = 'not required';
export const OPTIONAL = 'optional';
export const REQUIRED = 'required';

export const EXPRESSION_OF_INTEREST = 'expression of interest';
export const PENDING = 'pending';
export const ACCEPTED = 'accepted';
export const CONCLUDED = 'concluded';
export const REJECTED = 'rejected';
export const AMENDED = 'amended';

export const UPLOAD_LIMIT = 5;

// eslint-disable-next-line quotes
export const NOT_SURE = "I'm not sure";

export const MARKET_BUZZ_PAGE_SIZE = 5;

export const RECORDS_PER_PAGE_OPTIONS = Object.freeze([
  { label: '10', value: 10 },
  { label: '20', value: 20 },
  { label: '30', value: 30 },
  { label: '40', value: 40 },
  { label: '50', value: 50 },
]);

export const LONG_MONTHS = Object.freeze([
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
]);

export const NOTIFICATION_CONTEXT_TYPES = Object.freeze([
  { label: 'Contract Update', value: 'Contract Update' },
  { label: 'Direct Message', value: 'Direct Message' },
  { label: 'Contract Conversation', value: 'Contract Conversation' },
  { label: 'Verification Document Review', value: 'Verification Document Review' },
  { label: 'Request Assistance', value: 'Request Assistance' },
  { label: 'Contract Amendment', value: 'Contract Amendment' },
  { label: 'Contract Document Review', value: 'Contract Document Review' },
  { label: 'Contract Status Update', value: 'Contract Status Update' },
  { label: 'Product Listing Amendment', value: 'Product Listing Amendment' },
  { label: 'Bookmark Listing Update', value: 'Bookmark Listing Update' },
  { label: 'Buyer Listing Amendment', value: 'Buyer Listing Amendment' },
  { label: 'Bookmark Buyer Listing Update', value: 'Bookmark Buyer Listing Update' },
  { label: 'Product Specification Creation', value: 'Product Specification Creation' },
  { label: 'Product Listing Creation', value: 'Product Listing Creation' },
  { label: 'Buyer Listing Creation', value: 'Buyer Listing Creation' },
  { label: 'Listing Status Update', value: 'Listing Status Update' },
  { label: 'Support Messages', value: 'Support Messages' },
]);

export const PRODUCT_STATUS_OPTIONS = Object.freeze([
  { label: 'Active Listing', value: ACTIVE_LISTING },
  { label: 'Pending Listing', value: PENDING_LISTING },
  { label: 'Archived Listing', value: ARCHIVED_LISTING },
  { label: 'Sent For Amendment', value: SENT_FOR_AMENDMENT },
]);

export const FEATURED_RANKING_OPTIONS = Object.freeze([
  { label: 'None', value: 'None' },
  { label: '1', value: '1' },
  { label: '2', value: '2' },
  { label: '3', value: '3' },
  { label: '4', value: '4' },
  { label: '5', value: '5' },
  { label: '6', value: '6' },
  { label: '7', value: '7' },
  { label: '8', value: '8' },
  { label: '9', value: '9' },
  { label: '10', value: '10' },
]);

export const CONTRACT_STATUS_OPTIONS = Object.freeze([
  { label: 'Expression of interest', value: 'Expression of interest' },
  { label: 'Pending', value: 'Pending' },
  { label: 'Accepted', value: 'Accepted' },
  { label: 'Concluded', value: 'Concluded' },
  { label: 'Rejected', value: 'Rejected' },
  { label: 'Message', value: 'Message' },
  { label: 'Assistance', value: 'Assistance' },
]);
